// Editorial imagery — reference by key everywhere. Do not add raw URLs at call sites.
export const IMAGES = {
  // Legacy sector imagery — retained where the Home Investment Focus grid still needs
  // recurring visual identity for slots 4 (Private Equity) and 7 (Strategic Partnerships).
  sector_tower:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/cfd1e3265a2c4672091e5de0704c88a95f5a525a677ad6e536a03b08ac9a55bd.png",
  contact_stone_entrance: "/generated/contact_stone_entrance_v2.png",
  firmBoardroom: "/generated/firm_boardroom_v2.png",
  strategy_hero_lng_arrival: "/generated/strategy_hero_lng_arrival_v1.png",
  strategy_battery_separator: "/generated/strategy_battery_separator_v1.png",
  insightsStill:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/03bb686948e86d213ec22f6cbfdd767588cd74e352183df0d2b96a55613d18fd.png",
  leadershipArchitectural: "/generated/leadership_colonnade_v1.png",
  globalSkyline: "/generated/global_atmosphere_v3.png",
  contactInterior:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/300528c945128cb7ec83219deb6bad34f3f39377fec6a6a0e5b594f0dc6a3e09.png",

  // Letter imagery (referenced by seeded letters data)
  letter_long_term:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/80100c970e34b7a664f8ff8541187b38e3c1828ad2f0d09e3d3d7c7fc89da534.png",
  letter_operational:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/7859ea428cdf12f91f571ba6d5d849b9a4c118bf190db2221da06cdea10e20f1.png",
  letter_private_equity:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/fe286380a0538dfd4a37efdbc7be98a914dde293a80382fdb097e830296b0d95.png",
  letter_infrastructure:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/337ced515158ea263cdd27ec4766abf9cb268a754d25e90a576d21572ef8d39f.png",
  letter_uncertain:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/be4ab2964bed20bf787502c0e67ef36a6bfb6581f9e978df32f0fe914090fead.png",

  // Menu / careers
  menu_panel:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/ce03fd7cd5be48139ae0dcea6c6e01c2e3147b50e61cf7e986d9c3aed360b20d.png",
  careers_hero: "/generated/careers_corridor_v1.png",
  investors_reading_corner: "/generated/investors_reading_corner_v1.png",

  // Letters index hero
  letters_dark_hero:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/cba2ba6da285755a8624243ccbed972442d9057562404d5430964bf01ca02764.png",

  // Modern library — Home anchor
  modern_library_night:
    "https://static.prod-images.emergentagent.com/jobs/92d77aa7-c0ef-4a5c-99ba-1c5214c2875a/images/6476742b38b9cab958f9d1ca36fa2398f60490bee637259f0559aa59978c57e5.png",

  // Phase 8 — locked institutional imagery (Nano Banana renders, Jul 2026)
  home_hero_promenade: "/generated/home_hero_promenade_final_v2b.png",
  letters_hero_desk: "/generated/letters_hero_desk_v3.png",

  // Home Investment Focus — commissioned photo series (Jul 2026)
  home_focus_industrial_battery: "/generated/home_focus_industrial_battery_v1.png",
  home_focus_energy_lng_jetty: "/generated/home_focus_energy_lng_jetty_v1.png",
  home_focus_infrastructure_airport_roof: "/generated/home_focus_infrastructure_airport_roof_v2.png",
  home_focus_special_situations_boardroom: "/generated/home_focus_special_situations_boardroom_v1.png",
  home_focus_crossborder_airport_apron: "/generated/home_focus_crossborder_airport_apron_v2.png",
  home_focus_family_hq: "/generated/home_focus_family_heritage_v3.png",

  // Investment Strategy — commissioned photo series (Jul 2026)
  // One anchor light per frame · midnight-navy · cold twilight only
  strategy_pe_facade: "/generated/strategy_pe_facade_v3.png",
  strategy_industrial_terminal: "/generated/strategy_industrial_terminal_v1.png",
  strategy_bridge: "/generated/strategy_bridge_v1.png",
  strategy_refinery: "/generated/strategy_energy_refinery_v2.png",
  strategy_manufacturing_floor: "/generated/strategy_manufacturing_floor_v1.png",
  strategy_command_center: "/generated/strategy_command_center_v1.png",
  strategy_port_elevated: "/generated/strategy_port_elevated_v2.png",
  strategy_family_boardroom: "/generated/home_focus_family_walnut_boardroom_v1.png",
  strategy_semi_corridor: "/generated/strategy_semi_corridor_v1.png",
  strategy_lng_terminal: "/generated/strategy_lng_terminal_v2.png",
  strategy_quote_pylons: "/generated/strategy_quote_pylons_v2.png",
};
